<template>
  <Modal
    title="Emitir Endosso"
    @close="closeModal"
    :active.sync="showModal"
    data-testId="activate-endorsement-popup"
  >
    <div>
      <span style="font-size: 16px"
        >Tem certeza que deseja emitir esse endosso?</span
      >
      <div class="form-row mt-2" v-if="isRefundFromCreditCard">
        <div class="form-group" style="text-align: left">
          <label>Forma de restituição</label>
          <v-select
            v-model="formData.refund_method"
            class="form-vs-input"
            :options="refundMethodOptions"
            :reduce="(option) => option.value"
            :clearable="false"
            data-testId="activate-endorsement-refund-method-select"
          />
        </div>
      </div>
      <center>
        <div class="d-flex justify-end">
          <vs-button
            @click="confirmIssue()"
            color="success"
            class="mb-6 mt-10 mr-2 btn-block"
            data-testId="activate-endorsement-popup-save-button"
          >
            <span>Emitir endosso</span>
          </vs-button>
          <vs-button
            @click="closeModal"
            color="grey"
            class="mb-6 mt-10 ml-2 btn-block"
            data-testId="activate-endorsment-popup-cancel-button"
          >
            <span>Cancelar</span>
          </vs-button>
        </div>
      </center>
    </div>
  </Modal>
</template>

<script>
import Modal from '../../components/Modal.vue';
import vSelect from 'vue-select';
import { PAYMENT_METHODS, REFUND_METHOD_TYPES } from '@/utils/constants';
import endorsementApi from '@/services/endorsement.api';

export default {
  components: {
    Modal,
    vSelect,
  },
  props: ['popupActive', 'endorsement'],
  watch: {
    popupActive: function (newValue) {
      this.showModal = newValue;
    },
  },
  data() {
    return {
      showModal: false,
      formData: {
        refund_method: REFUND_METHOD_TYPES.CREDIT_CARD,
      },
      refundMethodOptions: [],
    };
  },
  computed: {
    isRefundFromCreditCard() {
      return (
        this.endorsement &&
        this.endorsement.endorsement.prize &&
        this.endorsement.endorsement.prize.prize < 0 &&
        this.endorsement.previousPolicy.paymentMethodId ===
          PAYMENT_METHODS.CREDIT_CARD.id
      );
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    confirmIssue() {
      if (!this.isRefundFromCreditCard) {
        this.formData.refund_method = REFUND_METHOD_TYPES.PIX.id;
      }
      this.$emit('confirm-issue', this.formData);
    },
    getRefundMethodsOptions() {
      endorsementApi
        .getRefundMethods()
        .then((res) => {
          this.refundMethodOptions = res.map((method) => ({
            label: method.name,
            value: method.id,
          }));
        })
        .catch((error) => {
          console.error('Erro ao buscar formas de restituição:', error);
        });
    },
  },
  created() {
    this.getRefundMethodsOptions();
  },
};
</script>
